<!--
 * @Author: your name
 * @Date: 2021-07-29 10:37:53
 * @LastEditTime: 2026-08-24 15:12:43
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\app\uploadingList.vue
-->
<template>
  <div class="form-dialog">
    <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('aci5')" name="pSend">
        <div class="d-list">
          <!-- <el-table :data="issueList">
        <el-table-column prop="name" :label="$t('app.TerminalName')" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('app.ReleaseSchedule')">
          <div slot-scope="scope">
            <el-progress :percentage="parseInt(scope.row.downloaded)"></el-progress>
            <span show-overflow-tooltip class="ellipsis-1">{{scope.row.publish_no}}</span>
          </div>
        </el-table-column>
        <el-table-column :label="$t('app.status')" width="80">
          <span slot-scope="scope">{{scope.row.download_state|status}}</span>
        </el-table-column>
        <el-table-column :label="$t('app.operate')" width="160">
          <div slot-scope="scope">
            <el-button
              size="mini"
              @click="downloadHandler('retransmission', scope.row)"
              :disabled="scope.row.download_state == 3"
            >{{$t('app.retransmission')}}</el-button>
            <el-button size="mini" type="danger" @click="downloadHandler('cancel', scope.row)">{{$t('app.Cancel')}}</el-button>
          </div>
        </el-table-column>
      </el-table> -->
          <ul class="flex-b-c" style="height:48px;color: #909399;">
            <li style="width: 300px;">{{ $t('cbu1') }}</li>
            <li style="width: 300px;">{{ $t('cbu2') }}</li>
            <li style="width: 200px;">{{ $t('cbu3') }}</li>
            <li style="width: 120px;">{{ $t('cbu4') }}</li>
          </ul>
          <el-collapse v-model="activeNames" @change="handleChange" accordion>
            <div v-for="item in issueList" :key="item.dc_id">
              <el-collapse-item :name="item.dc_id">
                <ul slot="title" class="flex-b-c" style="width: 100%;border-top: 1px solid #EBEEF5;">
                  <li style="width: 300px;" class="ellipsis-1">{{ item.name }}</li>
                  <li class="progress-progress" style="width: 300px; height:48px">
                    <el-progress :percentage="parseInt(item.downloaded)" style="height:16px"></el-progress>
                    <div style="height:16px;line-height: 16px;">{{ item.publish_name || item.publish_no }}</div>
                  </li>
                  <!-- <li style="width: 60px;">{{item.download_state|status}}</li> -->
                  <li style="width: 200px;">{{ filtersDownload(item.download_state) }}</li>
                  <li @click="(event) => { event.stopPropagation() }">
                    <el-button size="mini" @click="downloadHandler('retransmission', item)"
                      :disabled="item.download_state == 3">{{ $t('app.retransmission') }}</el-button>
                    <el-button size="mini" type="danger" @click="downloadHandler('cancel', item)">{{ $t('app.Cancel')
                    }}</el-button>
                  </li>
                </ul>
                <div style="margin-left: 32px;">
                  <el-table :data="item.play_list">
                    <el-table-column prop="name" :label="$t('schedule.ProgramName')"
                      show-overflow-tooltip></el-table-column>
                    <el-table-column prop="size_remark" :label="$t('schedule.Resolution')"></el-table-column>
                    <el-table-column :label="$t('schedule.playTimes')">
                      <span slot-scope="scope">{{ scope.row.play_time ? msFormatting(scope.row.play_time) : "--:--:--"
                      }}</span>
                    </el-table-column>
                  </el-table>
                </div>
              </el-collapse-item>
            </div>
          </el-collapse>
        </div>
        <div class="d-btn">
          <el-button v-if="true" type="warning" @click="downloadHandler('cancelAll')" round>{{ $t('app.CancelAll')
          }}</el-button>
          <el-button v-if="true" type="primary" @click="downloadHandler('retransmissionAll')" round>{{
            $t('app.AllRetransmission') }}</el-button>
          <el-button type="success" @click="downloadHandler('accomplish')" round>{{ $t('app.ClearanceToComplete')
          }}</el-button>
          <el-button type="danger" @click="downloadHandler('clearAll')" round>{{ $t('app.RemoveAll') }}</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('aci6')" name="gSend">
        <play-list-table class="tab" ref="mytable" id="botto" :pagesize="6"></play-list-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('aci4')" name="counters">
        <counters-table class="tab" :pagesize="6"></counters-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PlayListTable from '../schedule/PlayListTable.vue'
import CountersTable from '../schedule/CountersTable.vue'
// import superClone from '@/assets/scripts/superClone.js'
import { msFormatting } from "@/assets/scripts/dateFormatting.js";
export default {
  name: 'UploadingList',
  props: {
    issueList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    PlayListTable,
    CountersTable,
  },
  data() {
    return {
      deviceList: [],
      activeNames: "",
      msFormatting,
      activeName: 'pSend',
      pollCount: 0,
      pollTimer: null,
      waitTimer: null,
      issueListChanged: false
    }
  },
  created() {
    this.waitTimer = setTimeout(() => {
      if (!this.issueListChanged) {
        this.startPolling();
      }
    }, 3000);
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearTimeout(this.pollTimer);
    }
    if (this.waitTimer) {
      clearTimeout(this.waitTimer);
    }
  },
  watch: {
    issueList: {
      handler() {
        this.issueListChanged = true;
        if (this.waitTimer) {
          clearTimeout(this.waitTimer);
        }
      },
      deep: true
    }
  },
  methods: {
    startPolling() {
      this.pollCount = 0;
      this.poll();
    },
    poll() {
      this.$emit("getIssueList");
      this.pollCount++;
      if (this.pollCount < 5) {
        this.pollTimer = setTimeout(() => {
          this.poll();
        }, 3000);
      }
    },
    handleChange(val) {
      console.log(val);
    },
    async downloadHandler(type, device) {
      switch (type) {
        case "cancel": { // 取消
          // let deviceList = [{
          //   id: device.device_id,
          //   sn: device.sn,
          //   type_id: device.type_id,
          //   cache: { dc_id: device.dc_id },
          //   myData: { stop_command_id: device.command_id }
          // }];
          let deviceList = this.version([device]);
          deviceList.highV.length > 0 && this.stopDownload(this.cancelAll(deviceList.highV));
          deviceList.lowV.length > 0 && this.stopDownloadLow(this.cancelAllLow(deviceList.lowV));
        } break;
        case "cancelAll": { // 取消全部
          let deviceList = this.version(this.issueList);
          this.stopDownload(this.cancelAll(deviceList.highV));
          this.stopDownloadLow(this.cancelAllLow(deviceList.lowV));
        } break;
        case "retransmission": { // 重传
          let deviceListObj = {};
          deviceListObj[device.command_id] = {
            publish_id: device.command_id,
            device_ids: [device.device_id]
          }
          device.download_state = "0";
          this.playlistReload(deviceListObj);
        } break;
        case "retransmissionAll": { // 重传全部
          this.playlistReload(this.getCommandId(this.issueList));
        } break;
        case "accomplish": { // 清除完成
          // this.deviceList = [];
          // this.issueList.forEach((row) => { this.deviceList.push(row.dc_id); });
          // this.deviceList.length > 0 && this.delDownloadList(this.deviceList, 3);
          this.delDownloadList('completed');
        } break;
        case "clearAll": { // 清除全部
          // this.deviceList = [];
          // this.issueList.forEach((row) => { this.deviceList.push(row.dc_id); });
          // this.deviceList.length > 0 && this.delDownloadList(this.deviceList, -1);
          let deviceList = this.version(this.issueList);
          await this.stopDownload(this.cancelAll(deviceList.highV));
          await this.stopDownloadLow(this.cancelAllLow(deviceList.lowV));
          await this.delDownloadList('all');
        } break;
        default: break;
      }
    },
    // 重传
    getCommandId(list) {
      // let issueList = superClone(list);
      let issueList = list.filter(item => item.download_state != "3");
      console.log(issueList);
      let deviceList = [];
      // this.issueList.forEach((item) => {
      //   if (item.download_state != "3") {
      //     commandList.findIndex(commandId => commandId === item.command_id) < 0 && commandList.push(item.command_id);
      //   }
      // });
      for (let i = 0; i < issueList.length; i++) {
        issueList[i].download_state = "0";
        deviceList.push({
          publish_id: issueList[i].command_id,
          device_ids: [issueList[i].device_id]
        });
        for (let j = i + 1; j < issueList.length; j++) {
          if (issueList[j].command_id === deviceList[i].publish_id) {
            deviceList[i].device_ids.push(issueList[j].device_id);
            issueList.splice(j, 1);
            j--;
          }
        }
      }
      let deviceListObj = {};
      for (let i = 0; i < deviceList.length; i++) {
        deviceListObj[deviceList[i].publish_id] = deviceList[i];
      }
      return deviceListObj;
    },
    // 重传与重传全部
    playlistReload(deviceList) {
      this.$http.post("/admin/publish/republish", { republish_info: encodeURIComponent(JSON.stringify(deviceList)) }, () => {
        // this.$emit("getIssueList");
      });
    },
    // 取消发送高版本
    cancelAll(issueList) {
      let deviceList = [];
      issueList.forEach((item) => {
        if (item.download_state != "3") {
          deviceList.findIndex(device => device.id === item.device_id) < 0 && deviceList.push({
            id: item.device_id,
            sn: item.sn,
            type_id: item.type_id,
            cache: { dc_id: item.dc_id },
            myData: { stop_command_id: item.command_id },
            name: item.name
          });
        }
      });
      return deviceList;
    },
    // 取消发送低版本
    cancelAllLow(issueList) {
      let deviceList = [];
      issueList.forEach((item) => {
        if (item.download_state != "3") {
          deviceList.findIndex(device => device.id === item.device_id) < 0 && deviceList.push({
            dc_id: item.dc_id,
            command_id: item.command_id,
            type_id: item.type_id,
            sn: item.sn,
            name: item.name
          });
        }
      });
      return deviceList;
    },
    version(issueList) {
      let highV = [];
      let lowV = [];
      issueList.forEach((item) => {
        let v = 217;
        if (item.system_version) {
          v = item.system_version.match(/\d+/g)[3];
        }
        if (parseInt(v) < 218) {
          // console.log("低版本");
          lowV.push(item);
        } else {
          // console.log("高版本");
          highV.push(item);
        }
      })
      return { highV, lowV }
    },
    // getDeviceList() {
    //   this.deviceList = [];
    //   this.issueList.forEach((item) => {
    //     item.download_state != "3" && this.deviceList.push({
    //       command_id: item.command_id,
    //       dc_id: item.dc_id,
    //       device_id: item.device_id,
    //       device_sn: item.sn
    //     });
    //   });
    // },
    // 取消与取消全部
    async stopDownload(deviceList) {
      if (deviceList.length === 0) {
        return;
      }
      await this.$http.post("/admin/Command/generalCommand", {
        request_type: 'set',
        device_select_mode: 'multiple',
        devices_info: encodeURIComponent(JSON.stringify(deviceList)),
        commands_info: encodeURIComponent(JSON.stringify([{ type: "stop_download", data: [] }]))
      }, () => {
        // this.$emit("getIssueList");
      });
    },
    // 取消与取消全部低版本设备发送
    async stopDownloadLow(deviceList) {
      if (deviceList.length === 0) {
        return;
      }
      await this.$http.post("/admin/Command/stopDownload", {
        stop_download_infos: encodeURIComponent(JSON.stringify(deviceList))
      }, () => {
        // this.$emit("getIssueList");
      });
    },
    // 清空与清空全部
    delDownloadList(type) {
      // deviceList, status
      // this.$http.post("/admin/Command/delDownload", {
      //   dc_ids: encodeURIComponent(JSON.stringify(deviceList)),
      //   download_state: status
      // }, () => {
      //   this.$emit("getIssueList");
      // });
      this.$http.post("/admin/Command/delDownload", {
        del_type: type
      }, () => {
        this.$emit("getIssueList");
      });
    },
    filtersDownload(key) {
      switch (`${key}`) {
        case "0":
          return this.$t('temporary20');
        case "1":
          return this.$t('temporary21');
        case "2":
          return this.$t('temporary22');
        case "3":
          return this.$t('temporary23');
        case "4":
          return this.$t('temporary24');
        case "5":
          return this.$t('temporary25');
        case "6":
          return this.$t('temporary26');
        default:
          return this.$t('temporary27');
      }
    },
  },
  filters: {
    // 0-等待1-下载中2-下载失败3-下载成功4-断电失效5-设备离线6-取消
    status(key) {
      switch (`${key}`) {
        case "0": return this.$t('temporary20');
        case "1": return this.$t('temporary22');
        case "2": return this.$t('temporary23');
        case "3": return this.$t('temporary24');
        case "4": return this.$t('temporary25');
        case "5": return this.$t('temporary26');
        case "6": return this.$t('temporary27');
        default: return this.$t('temporary28');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-dialog {
  width: 100%;
  height: 600px;
  display: flex;
  flex-direction: column;

  .d-list {
    overflow: auto;
    height: 500px;

    .progress-progress {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    /deep/ .el-collapse-item__arrow {
      display: none;
    }
  }

  .d-btn {
    margin-top: 8px;
    height: 40px;
    display: flex;
    justify-content: center;

    .el-button+.el-button {
      margin-left: 20px;
    }
  }
}
</style>